"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityConfig = void 0;
const activity_core_1 = require("@ark/activity-core");
const utils_1 = require("@ark/utils");
exports.activityConfig = new activity_core_1.ActivityConfig({
    apiPrefix: 'nup-2026',
    name: 'NUP',
    description: 'NUP活动包',
    businessLocations: [utils_1.BusinessLocation.HK],
});
